import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function ConfirmDelete({ item, kind, note, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!item} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="confirm-delete-dialog" className="w-[calc(100%-1.5rem)] max-w-md rounded-xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this {kind}?</AlertDialogTitle>
          <AlertDialogDescription>
            <span data-testid="confirm-delete-name" className="block font-semibold text-stone-800 break-all">{item?.name || item?.original_filename || kind}</span>
            It will be removed from this listing and the Advertisement Order. Your other attachments stay in the same order.{note ? ` ${note}` : ""}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel data-testid="confirm-delete-cancel" className="h-11 rounded-full">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-delete-ok" onClick={onConfirm} className="h-11 rounded-full bg-red-700 hover:bg-red-800 text-white">Delete Attachment</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
